module.exports = __webpack_public_path__ + "static/help.229f2440.svg";